import React from 'react';
import { BookOpen, ArrowRight, ChevronLeft } from 'lucide-react';
import { useDbNavigate } from '../../context/DatabaseContext';
import { SUPPORTING_DOCS_GROUPS } from './supportingDocsConfig';

const SupportingDocsGroupPage = ({ groupId }) => {
  const navigate = useDbNavigate();
  const group = SUPPORTING_DOCS_GROUPS.find(g => g.id === groupId);

  if (!group) return null;

  return (
    <div className="stui-tab-body">
      <div className="stui-page-breadcrumb">
        <BookOpen size={20} className="stui-c-primary" />
        <h1 className="stui-page-breadcrumb-title">Supporting Documentation</h1>
        <span className="stui-page-breadcrumb-sep">/</span>
        <span className="stui-page-breadcrumb-label">{group.label}</span>
        <span className="stui-label-xs-muted">
          {group.items.length} {group.items.length === 1 ? 'item' : 'items'}
        </span>
      </div>

      <div className="stui-section-nav">
        <button className="stui-btn-ghost" onClick={() => navigate('/supportingdocs-dashboard')}>
          <ChevronLeft size={14} />Back
        </button>
        <span className="stui-c-muted">|</span>
        <span className="stui-section-nav-title">{group.label}</span>
        <span className="stui-label-xs-muted">
          {group.items.length} {group.items.length === 1 ? 'item' : 'items'} available
        </span>
      </div>

      <div className="stui-card-grid">
        {group.items.map(item => (
          <div
            key={item.slug}
            className="stui-tile stui-clickable"
            onClick={() => navigate(`/${item.slug}`)}
          >
            <div className="stui-tile-header">
              <span className="stui-tile-title">{item.label}</span>
              <ArrowRight size={16} className="stui-c-muted" />
            </div>
            <div className="stui-tile-content">
              <p className="stui-tile-desc">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportingDocsGroupPage;
